import React from 'react';
import RelatorioOnibus from '../RelatorioOnibus';

const DashboardHome = () => {
    return (
        <>
        <RelatorioOnibus/>
        </>
    )
};

export default DashboardHome;
